import { useContext } from 'react';

import { UserProfile } from '../model';
import { UserProfileContext } from './context';

export const useUserProfile = (): UserProfile | null => {
  return useContext(UserProfileContext);
};
